// extracted by mini-css-extract-plugin
export default {"root":"AdmarktRegistrationStepCompany-root","link":"AdmarktRegistrationStepCompany-link"};